import { Grid } from "@mui/material";
import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import "../assets/styles/workTogether.css";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import handshake from "../assets/image/handshake.png";
import Wellcome from "../assets/image/Green_Pink_Boho_Aesthetic_Wedding_Planner_Circle_Logo__1_-removebg-preview.png";
import SendIcon from "../assets/image/sendIcon.svg";
import "../assets/styles/header.css";
const WorkTogether = () => {
  const form = useRef();

  const [open, setOpen] = useState(false);
  const [hello, setHello] = useState(true);
  const [msg, setMsg] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const handlePlayVideio = () => {
    setOpen((prev) => !prev);
    alert("click");
  };

  const handleSayhello = (e) => {
    e.preventDefault();
    if (name === "" || email == "" || msg === "") {
      return;
    }
    emailjs
      .sendForm(
        "service_d0kap6e",
        "template_y7d8wl4",
        form.current,
        "ejJFsvBIM7M9NYY0M"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div id="contact" className="work_together_container">
      <div className="work_together_content">
        <Grid container>
          <Grid item xs={12} md={1}></Grid>
          <Grid item xs={12} md={1}>
            <div>
              <div className="work_together_play_veideo">
                <p onClick={handlePlayVideio}>
                  <img
                    style={{
                      height: "50px",
                      width: "50px",
                      borderRadius: "50%",
                    }}
                    className="work_together_play_icon"
                    src={handshake}
                    alt=""
                  />
                </p>
                <img src={Wellcome} alt="" />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={1}></Grid>

          <Grid item xs={12} md={4}>
            <div className="lets_work_togther_details">
              <p> Let's work together</p>
              <span>
                Muhammad Junaid is a professional web developer. Feel free to
                get in touch with me.
              </span>
            </div>
          </Grid>
          <Grid item xs={12} md={1}></Grid>

          <Grid item xs={12} md={4}>
            <div
              className={
                hello
                  ? "work_togther_say_hello slide"
                  : "work_togther_say_hello"
              }
            >
              <form ref={form}>
                <div
                  className={
                    hello
                      ? "write_say_hello_message open"
                      : "write_say_hello_message"
                  }
                >
                  <input
                    name="name"
                    onBlur={(e) => setName(e.target.value)}
                    type="text"
                    placeholder="Name"
                  />
                  <input
                    name="email"
                    onBlur={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="email@gmail.com"
                  />
                  <textarea
                    className="textarea"
                    name="message"
                    onBlur={(e) => setMsg(e.target.value)}
                    placeholder="Write Message"
                  ></textarea>
                </div>
                <div className="say_hello_button">
                  <button onClick={handleSayhello}>
                    Say Hello
                    <img
                      style={{ height: "30px", width: "30px" }}
                      src={SendIcon}
                      alt=""
                    />
                  </button>
                </div>
              </form>
            </div>
          </Grid>
          <Grid item xs={12} md={1}></Grid>

          <Grid item xs={12} md={3}>
            <div className="work_togther_number">
              <p>+880163-900664</p>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="work_togther_email">
              <p>dev.junaid.bd@gmail.com</p>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div
              style={{
                width: "90%",
                display: "flex",
                alignItems: "center",
                marginTop: "68px",
                justifyContent: "flex-end",
              }}
            >
              <p style={{ color: "#bebdc4", fontSize: "12px" }}>
                STAY CONNECTED:
              </p>
              <div className="header_info_follow_icon">
                <a
                  href="https://github.com/MuhammadJunaid01"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <GitHubIcon style={{ color: "black" }} />
                </a>
              </div>
              <div className="header_info_follow_icon">
                <a
                  href="https://www.linkedin.com/in/mj-juanaid-7358b5216/"
                  target="_blank"
                >
                  <LinkedInIcon style={{ color: "#0077B5" }} />
                </a>
              </div>
              <div className="header_info_follow_icon">
                <a href="https://twitter.com/MJunaid05176495" target="_blank">
                  <TwitterIcon style={{ color: "#1DA1F2" }} />
                </a>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default WorkTogether;
